"use client";

import type { HTMLAttributes } from "react";
import { mergeClasses } from "@huub-web/utils";

import type { TypographyBodyVariant } from "../../theme/types";
import type { RequiredChildrenProp } from "../../props/ChildrenProp";
import { alignStyle, bodyStyle } from "./Body.css";
import { typography } from "../../theme/css/typography.css";

export type BodyProps = HTMLAttributes<HTMLDivElement> &
  RequiredChildrenProp & {
    chatMode?: boolean;
    variant?: TypographyBodyVariant;
    align?: "left" | "center" | "right";
  };

/**
 * Body component is used to display the main copy content of a page.
 * @deprecated Use Text instead
 */
export function Body({
  variant = "bodyM",
  align,
  chatMode = false,
  className,
  children,
  ...props
}: BodyProps) {
  return (
    <div
      className={mergeClasses(
        typography[variant],
        bodyStyle,
        alignStyle({ align }),
        chatMode ? "--chat-mode" : undefined,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
